module.exports = __webpack_public_path__ + "img/026.a753f46b.png";